import { useState } from "react"

export const useGlobalStates = () => {
    
    const [ showForm, setShowForm ] = useState(false)

    const [ stepApplilication, setStepApplilication]  = useState(0)
    const [ formOpeningMode, setFormOpeningMode ] = useState('EDITABLE')
    const [ modalOpeningMode, setModalOpeningMode ] = useState('EDITABLE')

    return Object.freeze({
        showForm, setShowForm,
        stepApplilication, setStepApplilication,
        modalOpeningMode, setModalOpeningMode,
        formOpeningMode, setFormOpeningMode
    })
}